export const validateRotateAmountMaxAmountLimit = (
  rotateAmountLimit: string | undefined,
  maximumAmountLimit: string | undefined,
  unlimitAmount?: boolean,
) => {
  if (unlimitAmount) {
    return {
      isValid: true,
      errorMsg: "",
    };
  }

  const rotateAmount = Number(rotateAmountLimit ?? 0);
  const maxAmount = Number(maximumAmountLimit ?? 0);

  if (rotateAmount <= 0) {
    return {
      isValid: false,
      errorMsg: "rotate_amount_limit_must_be_greater_than_zero",
    };
  }

  if (maxAmount <= 0) {
    return {
      isValid: false,
      errorMsg: "maximum_amount_limit_must_be_greater_than_zero",
    };
  }

  if (rotateAmount > maxAmount) {
    return {
      isValid: false,
      errorMsg: "rotate_amount_limit_must_be_less_than_maximum_amount_limit",
    };
  }

  return {
    isValid: true,
    errorMsg: "",
  };
};
